import React, { useState, useEffect } from 'react';
import { orders as ordersApi } from '../utils/api';
import { useToast } from '../hooks/useToast';

const INCOTERMS = ['FOB','CIF','EXW','CFR','DDP','FCA'];

export default function ShipmentTab({ quotation: q, onRefresh }) {
  const shipment = q.shipment;
  const { toast } = useToast();
  const [form, setForm] = useState({
    carrier: shipment?.carrier || '',
    tracking_number: shipment?.tracking_number || '',
    incoterm: shipment?.incoterm || 'FOB',
    estimated_departure: shipment?.estimated_departure || '',
    actual_departure: shipment?.actual_departure || '',
    estimated_arrival: shipment?.estimated_arrival || '',
    actual_arrival: shipment?.actual_arrival || '',
    notes: shipment?.notes || '',
  });
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setForm({
      carrier: shipment?.carrier || '',
      tracking_number: shipment?.tracking_number || '',
      incoterm: shipment?.incoterm || 'FOB',
      estimated_departure: shipment?.estimated_departure || '',
      actual_departure: shipment?.actual_departure || '',
      estimated_arrival: shipment?.estimated_arrival || '',
      actual_arrival: shipment?.actual_arrival || '',
      notes: shipment?.notes || '',
    });
    setDirty(false);
  }, [q.id]);

  function sf(k, v) { setForm(f => ({ ...f, [k]: v })); setDirty(true); }

  async function handleSave() {
    setSaving(true);
    try {
      await ordersApi.saveShipment(q.id, form);
      toast('Transporte salvo!', 'success');
      setDirty(false);
      onRefresh();
    } catch(e) { toast(e.response?.data?.error || 'Erro', 'error'); }
    finally { setSaving(false); }
  }

  return (
    <div style={{ padding: 24 }}>
      <div className="form-grid">
        <div className="form-group">
          <label>Transportadora / Agente de Carga</label>
          <input value={form.carrier} onChange={e => sf('carrier', e.target.value)} placeholder="Ex: Sinomax, DHL, etc." />
        </div>
        <div className="form-group">
          <label>Número de Rastreio / BL</label>
          <input value={form.tracking_number} onChange={e => sf('tracking_number', e.target.value)} placeholder="MSKU1234567" />
        </div>
        <div className="form-group">
          <label>Incoterm</label>
          <select value={form.incoterm} onChange={e => sf('incoterm', e.target.value)}>
            {INCOTERMS.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', marginBottom: 8, marginTop: 8 }}>DATAS DE SAÍDA</div>
        </div>
        <div className="form-group">
          <label>Previsão de Saída</label>
          <input type="date" value={form.estimated_departure} onChange={e => sf('estimated_departure', e.target.value)} />
        </div>
        <div className="form-group">
          <label>Saída Real</label>
          <input type="date" value={form.actual_departure} onChange={e => sf('actual_departure', e.target.value)} />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', marginBottom: 8, marginTop: 8 }}>DATAS DE CHEGADA</div>
        </div>
        <div className="form-group">
          <label>Previsão de Chegada</label>
          <input type="date" value={form.estimated_arrival} onChange={e => sf('estimated_arrival', e.target.value)} />
        </div>
        <div className="form-group">
          <label>Chegada Real</label>
          <input type="date" value={form.actual_arrival} onChange={e => sf('actual_arrival', e.target.value)} />
        </div>
        <div className="form-group" style={{ gridColumn: '1/-1' }}>
          <label>Observações</label>
          <textarea value={form.notes} onChange={e => sf('notes', e.target.value)}
            rows={3} placeholder="Informações adicionais de transporte..." style={{ resize: 'vertical' }} />
        </div>
      </div>
      {dirty && (
        <div style={{ marginTop: 16 }}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Salvando...' : '💾 Salvar Transporte'}
          </button>
        </div>
      )}
    </div>
  );
}
